export default "__VITE_ASSET__Dut05T9A__"